export default __webpack_public_path__ + "static/media/pic.6210e312.svg";